import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';
import { ProfileExamplesComponent } from '../../component/profile-examples/profile-examples.component';
import { SearchFormComponent } from '../../component/search-form/search-form.component';
import { BehaviorSubject } from 'rxjs';
import { EMPTY } from '../../util/const';
import { GreetingsComponent } from '../../component/greetings/greetings.component';
import { BenefitsComponent } from '../../component/benefits/benefits.component';
import { IBenefitsDTO } from '../../dto/benefits/benefits.dto';
import { benefitsDTO } from './seach-page.benefits';
import { IGreetingsDTO } from '../../dto/greetings/greetings.dto';
import { greetingsDTO } from './search-page.greetings';
import { MetaService } from '../../service/meta.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-search-page',
  imports: [
    NzRowDirective,
    NzColDirective,
    NzTypographyComponent,
    ProfileExamplesComponent,
    SearchFormComponent,
    GreetingsComponent,
    BenefitsComponent,
  ],
  templateUrl: './search-page.component.html',
  styleUrl: './search-page.component.less',
})
export class SearchPageComponent implements OnInit {
  public readonly valueBehaviorSubject$: BehaviorSubject<string> =
    new BehaviorSubject<string>(EMPTY);
  public readonly benefitsDTO: IBenefitsDTO = benefitsDTO;
  public readonly greetingsDTO: IGreetingsDTO = greetingsDTO;
  private readonly metaService: MetaService = inject(MetaService);

  public ngOnInit(): void {
    this.metaService.setTitle(
      $localize`:@@page-search-title:Instagram viewer. Explore profiles without login: Ig4u`
    );
    this.metaService.setDescription(
      $localize`:@@page-search-description:Instagram web viewer designed to provide you with seamless access to Instagram profiles without account. View all profile features effortlessly, without registration, using the Ig4u service!`
    );
    this.metaService.setKeywords(
      $localize`:@@page-search-keywords:instagram viewer, instagram profile viewer, instagram web viewer, instagram viewer without account, ig4u`
    );
    this.metaService.setCanonical(EMPTY);
    this.metaService.setAlternatives(EMPTY);
    this.metaService.enableIndexing();
  }
}
